//
//
//
//
//
//
//
//
//

export default {
  name: 'PromotionTournamentRankingRow',
  props: {
    position: { type: [Number, String], required: true },
    name: { type: String, required: true },
    points: { type: String, required: true },
    prize: { type: String, default: '' },
    highlight: { type: Boolean, default: false }
  }
}
